
import { ReactNode } from 'react';

interface TopNavigationProps {
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
  rightAction?: ReactNode;
  className?: string;
}

export default function TopNavigation({
  title,
  showBack = false,
  onBack,
  rightAction,
  className = ''
}: TopNavigationProps) {
  return (
    <div className={`fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md border-b border-gray-100 z-50 ${className}`}>
      <div className="flex items-center justify-between h-16 px-4">
        <div className="flex items-center gap-3">
          {showBack && (
            <button
              onClick={onBack}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            >
              <i className="ri-arrow-right-line text-xl text-[#333333]"></i>
            </button>
          )}
          {title && (
            <h1 className="text-lg font-bold text-[#333333]">{title}</h1>
          )}
        </div>
        
        {rightAction && (
          <div className="flex items-center gap-2">
            {rightAction}
          </div>
        )}
      </div>
    </div>
  );
}
